import React, { useContext, useEffect, useState } from "react";
import { Badge, Box, Card, Grid, IconButton, Typography } from "@mui/material";
import PageHeader from "../../../components/PageHeader";
import PackageTraking from "../../../components/PackageTraking";
import SidebarContext from "../../../context/SidebarContext";
import SimpleBar from "simplebar-react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import HelpIcon from "@mui/icons-material/Help";
import PackagesShopping from "./PackagesShopping";
import AllUsersShopping from "./AllUsersShoppping";
import OrderHistory from "../../../components/common/History/OrderHistory";
import OrderChats from "../../../components/common/orderChat/OrderChats";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { useDispatch, useSelector } from "react-redux";
import { setActiveComponent, setPackages, setRequests, setSelectedPackage, setSelectedRequest } from "../../../store/commonSlice";
import { getAllSuites, getShelfPackages, getShelfShoppingPackages, getWareHouses } from "../../../helper/functions";

function ShoppingRequest() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.value);
  const { selectedPackage: packageActiveData, activeComponent } = useSelector((state) => state.common);
  const { open } = useContext(SidebarContext);
  const [selectedFilters, setSelectedFilters] = useState({ routePartnerId: "", warehouseId: "" })
  const [filterOptions, setFilterOptions] = useState({
    routePartners: [],
    warehouses: [],
  });

  const getWarehouse = async (routerPartnerId) => {
    if (routerPartnerId) {
      const data = await getWareHouses({ routePartnerId: routerPartnerId });
      setFilterOptions(prev => ({ ...prev, warehouses: data }));
    }
  }
  const getPackages = async () => {
    try {
      const shelfShoppingPackage = await getShelfShoppingPackages([]);
      const usersMySuites = [];
      const extra = [];
      shelfShoppingPackage.map(
        (pack) =>
          !usersMySuites.includes(pack?.mySuiteId) &&
          usersMySuites.push(pack?.mySuiteId)
      );
      console.log(usersMySuites, "usersMySuites");
      if (selectedFilters?.routePartnerId) {
        extra.push({
          key: "routePartnerId",
          operator: "==",
          value: selectedFilters?.routePartnerId,
        });
      }
      if (selectedFilters?.warehouseId) {
        extra.push({
          key: "routePartnerMainAddressId",
          operator: "==",
          value: selectedFilters?.warehouseId,
        });
      }
      
      if (usersMySuites?.length > 0) {
        console.log(usersMySuites, "usersMySuitesusersMySuites");
        const allSuites = await getAllSuites([
          ...extra,
          {
            key: "__name__",
            operator: "in",
            value: usersMySuites,
          },
        ]);
        console.log(allSuites,"allSites in shopping");
        
        dispatch(setRequests(allSuites));
      }
      // dispatch(setPackages(shelfPackage));
    } catch (error) {
      // setLoading(false);
      console.log(error, "error");
    }
  };

  const chatClickHandler = async (e, id, item) => {
    e.stopPropagation();
    dispatch(setActiveComponent('Chats'))
    dispatch(setSelectedPackage(item));
  };

  const historyClickHandler = async (id, item, e) => {
    e.stopPropagation();
    dispatch(setActiveComponent('History'))
    dispatch(setSelectedPackage(item));
  };

  const userClickHandler = async (id, item) => {
    dispatch(setActiveComponent('Actions'))
    console.log(item,activeComponent,"details in userClickHandler");
    
    dispatch(setSelectedRequest(item));
    dispatch(setSelectedPackage(null));
  };

  const packageClickHandler = async (id, item) => {
    dispatch(setActiveComponent('Actions'))
    dispatch(setSelectedPackage(item));
  };

  const closeHistoryHandler = () => {
    dispatch(setActiveComponent('Actions'))
  };

  const changeFilterHandler = (filter) => {
    setSelectedFilters((prev) => ({ ...prev, ...filter }));
    dispatch(setSelectedRequest(null));
    dispatch(setSelectedPackage(null));
    getWarehouse(filter?.routePartnerId)
  };
  console.log(activeComponent,"activeComponent outside");
  
  useEffect(() => {
    if (user?.routePartnerId) {
      setSelectedFilters(prev => ({ ...prev, routePartnerId: user?.routePartnerId }));
      const querySnapshot = collection(db, "routePartnerMainAddress");

      const q = query(querySnapshot, where("routePartnerId", "==", user?.routePartnerId));
      onSnapshot(q, async (snapshot) => {
        const arr = [];
        snapshot.forEach((doc) => {
          arr.push({ ...doc.data(), id: doc.id });
        });
        setFilterOptions(prev => ({ ...prev, warehouses: arr }));
      });
    }
  }, [user])

  useEffect(() => {
    // handler();
    try {
      dispatch(setRequests([]));
      const querySnapshot = collection(db, "routePartners");
      const q = query(querySnapshot, where("isDeleted", "==", false));
      onSnapshot(q, (snapshot) => {
        const arr = [];
        snapshot.forEach((doc) => {
          arr.push({ ...doc.data(), id: doc.id });
        });
        setFilterOptions(prev => ({ ...prev, routePartners: arr }));
      });
    } catch (err) {
      console.log(err, "err");
    }
    return () => {
      dispatch(setSelectedPackage(null));
      dispatch(setSelectedRequest(null))
      dispatch(setPackages([]))
      dispatch(setRequests([]))
    }
  }, []);

  useEffect(() => {
    getPackages()
  }, [selectedFilters])

  const activeStep =
    packageActiveData?.packageTrackingStatus === "Ordered"
      ? 2
      : packageActiveData?.packageTrackingStatus === "Received"
        ? 3
        : packageActiveData?.packageTrackingStatus === "Done"
          ? 4
          : 1;

  const steps = [
    {
      label: "Requested",
      date: packageActiveData?.requestedAt
        ? new Date(
          packageActiveData?.requestedAt.seconds * 1000
        ).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        : "-",
    },
    {
      label: "Ordered",
      date: packageActiveData?.orderedAt
        ? new Date(
          packageActiveData?.orderedAt.seconds * 1000
        ).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        : "-",
    },
    {
      label: "Received",
      date: packageActiveData?.receivedAt
        ? new Date(
          packageActiveData?.receivedAt.seconds * 1000
        ).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        : "",
    },
    { label: "Done", date: "-" },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <PageHeader pageTitle={"Shoppings"} selectedFilters={selectedFilters} filterOptions={filterOptions} changeFilterHandler={changeFilterHandler} />
      <Box
        sx={{
          flex: 1,
          backgroundColor: "white",
          borderTop: "1px solid #E5E5E8",
        }}
      >
        <Grid
          container
          spacing={0}
          sx={{
            width: open === false ? "calc(97vw - 80px)" : "calc(97vw - 240px)",
          }}
        >
          <Grid item sm={12} md={3}>
            <AllUsersShopping
              userClickHandler={userClickHandler}
              selectedFilters={selectedFilters}
            />
          </Grid>
          <Grid
            item
            sm={12}
            md={3}
            sx={{
              borderLeft: "1px solid #E5E5E8",
              borderRight: "1px solid #E5E5E8",
            }}
          >
            <PackagesShopping
              packageClickHandler={packageClickHandler}
              historyClickHandler={historyClickHandler}
              chatClickHandler={chatClickHandler}
              selectedFilters={selectedFilters}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <SimpleBar
              forceVisible="y"
              autoHide={true}
              style={{ maxHeight: "88vh" }}
              className="custom-scrollbar"
            >
              {activeComponent === "Chats" && (
                <OrderChats
                  closeHistory={closeHistoryHandler}
                />
              )}
              {activeComponent === "History" && (
                <OrderHistory
                  closeHistory={closeHistoryHandler}
                />
              )}
              {activeComponent === "Actions" && (
                <PackageTraking
                  collection={"shelfShoppingPackages"}
                  steps={steps}
                  activeStep={activeStep}
                  pageName="shopping request"
                />
              )}
            </SimpleBar>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default ShoppingRequest;
